"use client";

export default function Error() {
  return <div>error boundary</div>;
}
